/**
 * @voltxampere/ui — 4584 hex Schmitt-trigger inverter CMOS variant (Sprint 43-7)
 *
 * Sprint 43 ADR-0064 introduced the Schmitt branch on the
 * `digital-gate` canonical type. 4584 is the classic 4000-series
 * CMOS Schmitt NOT — wider Vcc range (3-15 V) than 74HC14, slower
 * propagation. Default params target the Vcc=5 V case for parity
 * with 74HC14.
 *
 * Reference: Fairchild CD4584B / TI CD4584B. V_T+ ≈ 0.5×Vcc + 0.7,
 * V_T- ≈ 0.5×Vcc - 0.7 (ratiometric). At Vcc=5 V: V_T+ ≈ 3.2 V,
 * V_T- ≈ 1.8 V.
 *
 * Copyright © 2026 360 Studio
 * Licensed under MIT (see LICENSE file in repo root)
 */
import { opAmp } from "../op-amp.js";
export const logic4584 = {
    id: "4584",
    nameTr: "4584 (6'lı Schmitt NOT CMOS, DIP-14)",
    nameEn: "4584 (Hex Schmitt NOT CMOS, DIP-14)",
    shortcut: "U",
    category: "active",
    viewBox: opAmp.viewBox,
    terminals: opAmp.terminals,
    defaultLabel: "U",
    defaultValue: "4584",
    schemaType: "digital-gate",
    defaultParams: {
        gateFunction: "NOT",
        outputType: "schmitt",
        vHigh: 5,
        vLow: 0,
        threshold: 2.5,
        vThresholdPlus: 3.2,
        vThresholdMinus: 1.8,
        propagationDelay: 100e-9,
    },
    renderSVG: () => opAmp.renderSVG(),
};
//# sourceMappingURL=logic-4584.js.map